import{DialogComponent,DialogOpenEvent}from'@theme/dialog';import{CartAddEvent}from'@theme/events';class CartDrawerComponent extends DialogComponent{#summaryThreshold=0.5;connectedCallback(){super.connectedCallback();document.addEventListener(CartAddEvent.eventName,this.#handleCartAdd);this.addEventListener(DialogOpenEvent.eventName,this.#updateStickyState);}
disconnectedCallback(){super.disconnectedCallback();document.removeEventListener(CartAddEvent.eventName,this.#handleCartAdd);this.removeEventListener(DialogOpenEvent.eventName,this.#updateStickyState);}
#handleCartAdd=()=>{if(this.hasAttribute('auto-open')){this.showDialog();}};open(){this.showDialog();customElements.whenDefined('shopify-payment-terms').then(()=>{const installmentsContent=document.querySelector('shopify-payment-terms')?.shadowRoot;const cta=installmentsContent?.querySelector('#shopify-installments-cta');cta?.addEventListener('click',this.closeDialog,{once:true});});}
close(){this.closeDialog();}
#updateStickyState(){const{dialog}=(this.refs);if(!dialog)return;const content=dialog.querySelector('.cart-drawer__content');const summary=dialog.querySelector('.cart-drawer__summary');if(!content||!summary){dialog.setAttribute('cart-summary-sticky','false');return;}
const drawerHeight=dialog.getBoundingClientRect().height;const summaryHeight=summary.getBoundingClientRect().height;const ratio=summaryHeight / drawerHeight;dialog.setAttribute('cart-summary-sticky',ratio>this.#summaryThreshold?'false':'true');}}
if(!customElements.get('cart-drawer-component')){customElements.define('cart-drawer-component',CartDrawerComponent);}




document.addEventListener("click", function(e) {

  // APPLY COUPON
  if (e.target.classList.contains("apply-coupon-btn")) {

    let btn = e.target;
    let code = btn.getAttribute("data-code");

    let box = btn.closest(".custom-coupon-box");
    let message = box.querySelector(".coupon-message");

    let discountInput = document.querySelector("#cart-discount");
    let discountForm = document.querySelector(".cart-discount__form");

    if (!discountInput || !discountForm) {
      message.innerText = "System error. Try again.";
      return;
    }

    // Reset message
    message.innerText = "";
    message.classList.remove("success");

    // Set code
    discountInput.value = code;

    // Submit form
    discountForm.dispatchEvent(new Event("submit", { bubbles: true }));

    // Loading UI
    btn.innerText = "Applying...";
    btn.disabled = true;

    // Wait for Shopify response
    setTimeout(() => {

      let applied = document.querySelector(
        `.cart-discount__pill[data-discount-code="${code}"]`
      );

      let errorBox = document.querySelector(".cart-discount__error");

      if (applied) {
        // ✅ SUCCESS
        message.innerText = "Coupon applied successfully ✅";
        message.classList.add("success");

        btn.style.display = "none";
        box.querySelector(".remove-coupon-btn").style.display = "inline-block";

      } else if (errorBox && !errorBox.classList.contains("hidden")) {
        // ❌ ERROR FROM SHOPIFY
        let errorText =
          errorBox.querySelector("small:not(.hidden)")?.innerText ||
          "Invalid or expired coupon";

        message.innerText = errorText;
      } else {
        // ❌ FALLBACK
        message.innerText = "Coupon not applicable for this cart";
      }

      btn.innerText = "Apply";
      btn.disabled = false;

    }, 2000);
  }


  // REMOVE COUPON
  if (e.target.classList.contains("remove-coupon-btn")) {

    let btn = e.target;
    let code = btn.getAttribute("data-code");

    let box = btn.closest(".custom-coupon-box");
    let message = box.querySelector(".coupon-message");

    let removeBtn = document.querySelector(
      `.cart-discount__pill[data-discount-code="${code}"] .cart-discount__pill-remove`
    );

    if (removeBtn) {
      removeBtn.click();

      message.innerText = "Coupon removed";

      // Reset UI
      btn.style.display = "none";
      box.querySelector(".apply-coupon-btn").style.display = "inline-block";
    }
  }

});

setTimeout(() => {
  var applied = document.querySelector(".cart-discount__pill");

  if (applied) {
    e.target.style.display = "none";
    e.target.closest(".coupon-row").querySelector(".coupon-applied-msg").style.display = "block";
  }

}, 2000);

document.addEventListener("DOMContentLoaded", function() {
  var appliedCodes = document.querySelectorAll(".cart-discount__pill");

  appliedCodes.forEach(function(pill) {
    var code = pill.getAttribute("data-discount-code");

    var btn = document.querySelector(`.apply-coupon-btn[data-code="${code}"]`);

    if (btn) {
      btn.style.display = "none";
    }
  });
});